module.exports = __webpack_public_path__ + "static/media/speakers_logos_WSP.b500fd37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_WSP.jpg
// module id = 283
// module chunks = 0